import { AppEntity, ContactInformationSchema, PostalAddressSchema } from '@app/icare/db/schema/common'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'

export const NursingHomeId = entityId('nursingHome')

export type NursingHomeIdType = typeof NursingHomeId.Type

export const NursingHomeSchema = AppEntity.extend({
  id: NursingHomeId.schema,
  name: z.string().min(1).max(255),
  comment: z.string().nullish(),
  remarks: z.string().nullish(),
  serviceArea: z.string().max(255).nullish(),
  address: PostalAddressSchema.nullish(),
  contact: ContactInformationSchema.nullish(),
})

type NursingHomeFromSchema = z.infer<typeof NursingHomeSchema>
export type NursingHome = NursingHomeFromSchema
